import { useContext, useEffect } from 'react'
import { ThemeContext } from '@/shared/ui/providers'
import type { ResolvedTheme } from '@/shared/ui/providers'

export function useForceTheme(forced: ResolvedTheme): void {
  const ctx = useContext(ThemeContext)

  useEffect(() => {
    if (!ctx) return
    return ctx.pushForcedTheme(forced)
  }, [ctx, forced])
}
